export default {
    locale: {
        en: 'Englisch',
        de: 'Deutsch',
    },
    app: {
        title: 'This or That',
    },
};
